import React from 'react';

const AuthContext = React.createContext({
    user: null,
    setUser: (e) => {},
    signedIn: false,
    setSignedIn: (event) => {},
    email: "",
    setEmail: (event) => {},
    token: null,
    setToken: (event) => {},
    appStyle: {},
    appConfig: {},
    orgId: null,
    socket: null
})

export default AuthContext;